import { MoreVertical } from 'lucide-react';
import { memo } from 'react';
import CampaignRowMenu from './campaign-row-menu';
import {
    DropdownMenu,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";


interface CampaignActionsMenuProps {
    campaignId: string;
    shouldShowViewLogs?: boolean;
}

const CampaignActionsMenu: React.FC<CampaignActionsMenuProps> = ({ campaignId, shouldShowViewLogs = true }) => {
    console.log("campaignId", campaignId);

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button
                    variant="ghost"
                    size="icon"
                    onClick={(e) => e.stopPropagation()}
                    style={{ color: '#7f9887', width: 'fit-content' }}
                >
                    <MoreVertical className="h-4 w-4" />
                </Button>
            </DropdownMenuTrigger>

            <CampaignRowMenu
                campaignId={campaignId}
                shouldShowViewLogs={shouldShowViewLogs}
            />
        </DropdownMenu>
    );
};

export default memo(CampaignActionsMenu);